import i18n from '@/i18n';

const t = i18n.t.bind(i18n);

/** 通知发送目标类型，由后端明确返回，前端不可根据目标字段推断 */
export type NoticeTargetType = 'global' | 'datacenter' | 'workspace' | 'all_datacenters' | 'all_workspaces';

// 类型定义
export interface Notice {
  id: string;
  Inserted: boolean;
  content: string;
  creatorID: string;
  creatorName: string;
  creatorType: string;
  targetType?: NoticeTargetType | '';
  datacenter?: string;
  linkURL?: string;
  severity: 'Info' | 'Warning' | 'Critical';
  sourceEntity: string;
  sourceID: string;
  title: string;
  type: string;
  workspace?: string;
  readCount?: number;
  createTime?: string;
  createdAt?: string;
  updatedAt?: string;
}

export const DEFAULT_PAGINATION = {
  page: 1,
  limit: 12,
  total: 0,
} as const;

/** 列表默认按创建时间降序 */
export const DEFAULT_QUERY = {
  sortBy: 'createTime',
  order: 'desc',
} as const;

export const TYPE_OPTS = [
  { label: t('system:system.notification'), value: 'system' },
  { label: t('system:maintenance.notification'), value: 'maintenance' },
  { label: t('system:security.notification'), value: 'security' },
  { label: t('system:product.update'), value: 'update' },
];

export const SEVERITY_OPTS = [
  { label: t('data-center:information'), value: 'Info', color: 'blue' },
  { label: t('common:warning'), value: 'Warning', color: 'orange' },
  { label: t('common:critical'), value: 'Critical', color: 'red' },
];

export const CREATOR_TYPE_OPTS = [
  { label: t('system:system.administrator'), value: 'system' },
  { label: t('system:tenant.administrator'), value: 'ws_admin' },
  { label: t('system:data.center.administrator'), value: 'dc_admin' },
  { label: t('system:system.billing.service'), value: 'Billing' },
  { label: t('system:system.order.service'), value: 'Order' },
];

/** 通知发送范围选项 */
export const TARGET_TYPE_OPTS = [
  { label: t('system:notification.target.global'), value: 'global' },
  { label: t('system:notification.target.datacenter'), value: 'datacenter' },
  { label: t('data-center:specific.tenant'), value: 'workspace' },
  { label: t('system:notification.target.all.datacenters'), value: 'all_datacenters' },
  { label: t('system:notification.target.all.workspaces'), value: 'all_workspaces' },
];

// 过滤器配置（顺序与列表列一致：标题 → 内容 → 严重程度 → 类型 → 创建人）
export const FILTERS_CONFIG = [
  {
    key: 'title[like]' as const,
    label: t('system:title'),
    type: 'input' as const,
  },
  {
    key: 'content[like]' as const,
    label: t('system:content'),
    type: 'input' as const,
  },
  {
    key: 'severity[eq]' as const,
    label: t('system:severity.level'),
    type: 'select' as const,
    options: SEVERITY_OPTS,
  },
  {
    key: 'type[eq]' as const,
    label: t('common:type'),
    type: 'select' as const,
    options: TYPE_OPTS,
  },
  {
    key: 'creatorType[eq]' as const,
    label: t('common:creator'),
    type: 'select' as const,
    options: CREATOR_TYPE_OPTS,
  },
];

// 类型标签颜色映射
export const TYPE_COLORS = {
  system: 'gray',
  maintenance: 'cyan',
  security: 'red',
  update: 'green',
} as const;
